<template>
  <div class="agent-type-choice" :class="{ 'is-compact': compact }">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="agent-type-card"
      :class="{ active: Number(value) === option.value }"
      :disabled="disabled"
      @click="$emit('input', option.value)"
    >
      <img :src="option.image" :alt="option.label" class="agent-type-icon" />
      <strong>{{ option.label }}</strong>
      <small>{{ compact ? option.compactDescription : option.description }}</small>
    </button>
  </div>
</template>

<script>
import chatbotIcon from "@/assets/agent-ai/chatbot.png";
import chatAiIcon from "@/assets/agent-ai/chat-ai.png";

export default {
  name: "AgentTypeChoice",
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    compact: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [
        {
          value: 0,
          label: "Chatbot",
          image: chatbotIcon,
          description: "Balasan otomatis berbasis aturan",
          compactDescription: "Balasan berbasis aturan"
        },
        {
          value: 1,
          label: "Chat AI",
          image: chatAiIcon,
          description: "Menggunakan AI untuk menjawab",
          compactDescription: "AI dengan pengetahuan"
        }
      ]
    };
  }
};
</script>

<style scoped>
.agent-type-choice {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}
.agent-type-choice.is-compact {
  gap: 9px;
  margin-bottom: 10px;
}
.agent-type-card {
  text-align: left;
  border: 1px solid #e7eaf0;
  border-radius: 12px;
  background: #fff;
  padding: 14px;
  cursor: pointer;
  transition: border-color .18s ease, background-color .18s ease, box-shadow .18s ease;
}
.agent-type-choice.is-compact .agent-type-card {
  border-radius: 11px;
  padding: 11px;
}
.agent-type-icon {
  display: block;
  width: 44px;
  height: 44px;
  margin-bottom: 9px;
  object-fit: contain;
}
.agent-type-choice.is-compact .agent-type-icon {
  width: 38px;
  height: 38px;
  margin-bottom: 7px;
}
.agent-type-card strong {
  display: block;
  color: #344054;
  font-size: 13px;
}
.agent-type-choice.is-compact .agent-type-card strong {
  font-size: 12px;
}
.agent-type-card small {
  display: block;
  margin-top: 3px;
  color: #98a2b3;
  font-size: 12px;
  line-height: 1.4;
}
.agent-type-choice.is-compact .agent-type-card small {
  margin-top: 2px;
  font-size: 12px;
  line-height: 1.35;
}
.agent-type-card.active {
  border-color: #fe9b44;
  background: #fff8f1;
  box-shadow: 0 0 0 1px rgba(254, 155, 68, .18);
}
.agent-type-card.active strong {
  color: #e77f25;
}
.agent-type-card:disabled {
  cursor: not-allowed;
  opacity: .6;
}
@media (max-width: 575px) {
  .agent-type-choice {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ai/agentV2/components/AgentTypeChoice.vue